module.exports = __webpack_public_path__ + "static/img/home_04.2494321.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_04.jpg
// module id = dsUk
// module chunks = 1